
import { MapUtils } from '../../utility/map-utils.js';
import { DataModelBuilder, isSameData, SerializationContext, SerializedData } from '../../models/dto/dto.js';
import { Component } from '../core/component.js';
import { CapacityRange } from '../../models/serializable/capacity-range.js';

export class ServiceCapacityComponent extends Component {
  static readonly TYPE_ID: string = 'fe990f50622b4682a7b54882b971a31d';

  constructor(
    public readonly capacity: CapacityRange,
  ) {
    super();
  }

  get $removable(): boolean {
    return false;
  }

  get $typeId(): string {
    return ServiceCapacityComponent.TYPE_ID;
  }

  static fromMap(context: SerializationContext, map: SerializedData): ServiceCapacityComponent {
    return new ServiceCapacityComponent(
        context.fromData<CapacityRange>(MapUtils.get<SerializedData>(map, 'capacity')),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'capacity': context.toData(this.capacity),
    };
  }

  clone(): this {
    return new ServiceCapacityComponent(
        this.capacity.clone(),
    ) as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return isSameData(other.capacity, this.capacity);
  }
}

export class ServiceCapacityComponentBuilder extends DataModelBuilder<ServiceCapacityComponent> {
  build(context: SerializationContext, map: SerializedData): ServiceCapacityComponent {
    return ServiceCapacityComponent.fromMap(context, map);
  }
}
